import { pstyle } from "../lib/pstyle.js";
import Hoverable from "../lib/Hoverable.jsx";

export default function Tshoot({ v }) {
  return (
    <div style={pstyle("padding:48px 44px 80px; max-width:1000px; margin:0 auto; display:flex; flex-direction:column; gap:26px;")}>
      <div style={pstyle("display:flex; flex-direction:column; gap:10px;")}>
        <h1 style={pstyle("margin:0; font-size:32px; font-weight:600; letter-spacing:-0.025em;")}>Arbres de décision</h1>
        <p style={pstyle("margin:0; font-size:15px; color:oklch(0.5 0.015 60);")}>Un symptôme, une question à la fois, une commande à chaque étape.</p>
      </div>
      <div style={pstyle("display:flex; gap:8px; flex-wrap:wrap;")}>
        {v.treeTabs.map((t, i) => (
          <button key={i} type="button" onClick={t.onClick} style={pstyle("font:inherit; font-size:13px; border-radius:999px; padding:6px 14px; cursor:pointer;", { border: "1px solid " + t.border, color: t.color, background: t.bg })}>{t.label}</button>
        ))}
      </div>

      <div style={pstyle("display:grid; grid-template-columns:minmax(0,1fr) 280px; gap:40px; align-items:start;")}>
        <div style={pstyle("display:flex; flex-direction:column; gap:20px;")}>
          {v.treeTrail.map((s, i) => (
            <div key={i} style={pstyle("display:flex; gap:14px; padding-left:2px;")}>
              <span style={pstyle("width:22px; height:22px; flex:none; border-radius:50%; background:oklch(0.46 0.075 55); color:oklch(0.98 0.005 85); display:flex; align-items:center; justify-content:center; font-family:'IBM Plex Mono', monospace; font-size:11px;")}>{s.n}</span>
              <div style={pstyle("display:flex; flex-direction:column; gap:3px;")}>
                <span style={pstyle("font-size:14px; color:oklch(0.45 0.015 60);")}>{s.question}</span>
                <span style={pstyle("font-size:14px; color:oklch(0.24 0.012 60);")}>→ {s.answer}</span>
              </div>
            </div>
          ))}

          {v.treeAsking && (
            <div style={pstyle("border:1px solid oklch(0.9 0.01 85); border-radius:9px; padding:24px 26px; display:flex; flex-direction:column; gap:16px;")}>
              <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:11.5px; letter-spacing:0.08em; text-transform:uppercase; color:oklch(0.46 0.075 55);")}>{v.treeStepLabel}</span>
              <p style={pstyle("margin:0; font-size:19px; line-height:1.5; letter-spacing:-0.01em; text-wrap:pretty;")}>{v.treeQuestion}</p>
              {v.treeHasCheck && (
                <pre style={pstyle("margin:0; padding:12px 14px; background:oklch(0.19 0.012 60); border-radius:7px; font-family:'IBM Plex Mono', monospace; font-size:12.5px; line-height:1.7; color:oklch(0.9 0.02 90); white-space:pre-wrap;")}>{v.treeCheck}</pre>
              )}
              <div style={pstyle("display:flex; flex-direction:column; gap:8px;")}>
                {v.treeOptions.map((o, i) => (
                  <Hoverable
                    key={i}
                    onClick={o.onClick}
                    style={pstyle("border:1px solid oklch(0.92 0.008 85); border-radius:7px; padding:13px 16px; font-size:14.5px; color:oklch(0.28 0.015 60); cursor:pointer;")}
                    hoverStyle={{ borderColor: "oklch(0.46 0.075 55)", color: "oklch(0.46 0.075 55)" }}
                  >
                    {o.label}
                  </Hoverable>
                ))}
              </div>
            </div>
          )}

          {v.treeDone && (
            <div style={pstyle("border:1px solid oklch(0.86 0.03 60); border-radius:9px; overflow:hidden;")}>
              <div style={pstyle("padding:22px 26px; display:flex; flex-direction:column; gap:12px; background:oklch(0.99 0.006 60);")}>
                <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:11.5px; letter-spacing:0.08em; text-transform:uppercase; color:oklch(0.46 0.075 55);")}>Cause probable</span>
                <p style={pstyle("margin:0; font-size:20px; line-height:1.45; letter-spacing:-0.015em;")}>{v.treeVerdict}</p>
                <p style={pstyle("margin:0; font-size:14.5px; line-height:1.7; color:oklch(0.38 0.015 60); text-wrap:pretty;")}>{v.treeFix}</p>
              </div>
              <pre style={pstyle("margin:0; padding:16px 20px; background:oklch(0.19 0.012 60); font-family:'IBM Plex Mono', monospace; font-size:12.5px; line-height:1.8; color:oklch(0.9 0.02 90); white-space:pre-wrap;")}>{v.treeCommand}</pre>
              <div style={pstyle("display:flex; align-items:center; gap:16px; padding:12px 20px; border-top:1px solid oklch(0.93 0.008 85); font-size:13.5px;")}>
                <button type="button" onClick={v.treeArticle} style={pstyle("background:none; border:none; padding:0; font:inherit; color:oklch(0.46 0.075 55); cursor:pointer;")}>Ouvrir la fiche : {v.treeArticleTitle}</button>
                <button type="button" onClick={v.resetTree} style={pstyle("background:none; border:none; padding:0; font:inherit; margin-left:auto; color:oklch(0.5 0.015 60); cursor:pointer;")}>Recommencer</button>
              </div>
            </div>
          )}
        </div>

        <div style={pstyle("display:flex; flex-direction:column; gap:12px;")}>
          <div style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Progression</div>
          <div style={pstyle("font-size:13px; line-height:1.65; color:oklch(0.5 0.015 60);")}>{v.treeProgress}</div>
          <button type="button" onClick={v.resetTree} style={pstyle("background:none; border:none; padding:0; font:inherit; text-align:left; font-size:13px; color:oklch(0.46 0.075 55); cursor:pointer;")}>Réinitialiser l'arbre</button>
        </div>
      </div>
    </div>
  );
}
